// extracted by mini-css-extract-plugin
export default {"parent":"Avatar_parent_M18I1","avatar":"Avatar_avatar_FZLII","badge":"Avatar_badge_VW0Z0"};